export default "__VITE_ASSET__BgTIHf6V__"